import { render, staticRenderFns } from "./comOnlineOrders.vue?vue&type=template&id=2307a751&scoped=true"
import script from "./comOnlineOrders.vue?vue&type=script&lang=js"
export * from "./comOnlineOrders.vue?vue&type=script&lang=js"
import style0 from "./comOnlineOrders.vue?vue&type=style&index=0&id=2307a751&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2307a751",
  null
  
)

export default component.exports